import { entities, EntityPushResponse, TimeRange, OnNext } from "sbtech-sports-data-api-client";
import { SportDataGatewayQueryInfo } from "sb-resp-lib";

export type SportApiQueryFactory = (handler: OnNext<EntityPushResponse<entities.Sport, entities.SportChange>>) => SportDataGatewayQueryInfo<EntityPushResponse<entities.Sport, entities.SportChange>>;
export type TodaySportApiQueryFactory = (fromProvider: ()=> Date) => SportApiQueryFactory;

export const preLiveSportApiQuery = (handler: OnNext<EntityPushResponse<entities.Sport, entities.SportChange>>, languageCode: string, from: Date) => {
        const query = "$filter=fixturesCount gt 0";
        const queryInfo = new SportDataGatewayQueryInfo(query, handler);
        queryInfo.timeRange = TimeRange.SixHours;
        queryInfo.locale = languageCode;
        queryInfo.from = from.toISOString();
        return queryInfo;
}

export const preLiveSportApiQueryFactory = (languageCode: string, dateConstructor: DateConstructor): SportApiQueryFactory => {
        return (handler: OnNext<EntityPushResponse<entities.Sport, entities.SportChange>>) =>
         preLiveSportApiQuery(handler, languageCode, new  dateConstructor());
}

export const liveSportApiQuery = (handler: OnNext<EntityPushResponse<entities.Sport, entities.SportChange>>, languageCode: string) => {
        const query = "$filter=liveFixturesTotalCount gt 0 or liveOutrightsTotalCount gt 0";
        const queryInfo = new SportDataGatewayQueryInfo(query, handler);
        queryInfo.locale = languageCode;
        return queryInfo;
}

export const liveSportApiQueryFactory = (languageCode: string): SportApiQueryFactory => {
        return (handler: OnNext<EntityPushResponse<entities.Sport, entities.SportChange>>) => liveSportApiQuery(handler, languageCode);
}

export const todaySportApiQuery = (handler: OnNext<EntityPushResponse<entities.Sport, entities.SportChange>>, languageCode: string, from: Date) => {
        const queryInfo = new SportDataGatewayQueryInfo("", handler);
        queryInfo.timeRange = TimeRange.OneDay;
        queryInfo.locale = languageCode;
        queryInfo.from = from.toISOString();
        return queryInfo;
}

export const todaySportApiQueryFactory = (languageCode: string): TodaySportApiQueryFactory => {
        return  (fromProvider: () => Date) =>
                (handler: OnNext<EntityPushResponse<entities.Sport, entities.SportChange>>) =>
                todaySportApiQuery(handler, languageCode, fromProvider())
}